/**
 * Recommended test lineups from prototype/placeholder_content.md.
 * Team A = bottom half (rows rowsPerSide..2*rowsPerSide-1), team B = top half.
 */
import { defaultLoadout } from '../config/balance'
import type { TeamSetup, UnitSetup } from './types'

function u(champ: string, col: number, row: number, weapons?: string[]): UnitSetup {
  return { champ, hex: { col, row }, weapons: weapons ?? defaultLoadout[champ] ?? [] }
}

/** 1x each champion; positions mirrored across the center line (rowsPerSide=4 layout) */
export function mirrorTeams(): { a: TeamSetup; b: TeamSetup } {
  return {
    a: [u('ironguard', 3, 4), u('rogue', 1, 4), u('musketeer', 2, 5), u('hexmaster', 4, 5), u('cleric', 3, 6)],
    b: [u('ironguard', 3, 3), u('rogue', 1, 3), u('musketeer', 2, 2), u('hexmaster', 4, 2), u('cleric', 3, 1)],
  }
}

/** 3x Iron Guard + 2x Cleric vs 3x Rogue + 2x Musketeer — Taunt vs Sprung */
export function wallVsBurstTeams(): { a: TeamSetup; b: TeamSetup } {
  return {
    a: [u('ironguard', 2, 4), u('ironguard', 3, 4), u('ironguard', 4, 4), u('cleric', 2, 5), u('cleric', 4, 5)],
    b: [u('rogue', 2, 3), u('rogue', 3, 3), u('rogue', 4, 3), u('musketeer', 2, 2), u('musketeer', 4, 2)],
  }
}

/** 4x Hexmaster + 1x Cleric vs Mirror-Team — Gift-Stacking + Overtime */
export function dotStackTeams(): { a: TeamSetup; b: TeamSetup } {
  return {
    a: [u('hexmaster', 1, 5), u('hexmaster', 2, 5), u('hexmaster', 4, 5), u('hexmaster', 5, 5), u('cleric', 3, 6)],
    b: mirrorTeams().b,
  }
}

/** Content-Batch 1 (BATTLE-9): alle 10 neuen Champions in einem Kampf — deckt jede neue Ability ab */
export function batch1Teams(): { a: TeamSetup; b: TeamSetup } {
  return {
    a: [u('paladin', 3, 4), u('deathknight', 2, 4), u('monk', 4, 4), u('mage', 2, 5), u('tinker', 4, 5)],
    b: [u('druid', 3, 3), u('shaman', 2, 3), u('demonhunter', 4, 3), u('warlock', 2, 2), u('necromancer', 4, 2)],
  }
}

/** Alle 15 Champions gleichzeitig (8v7) — Determinismus-Stress fuer den vollen Katalog */
export function fullCatalogTeams(): { a: TeamSetup; b: TeamSetup } {
  return {
    a: [
      u('ironguard', 2, 4), u('paladin', 4, 4), u('deathknight', 3, 4), u('monk', 1, 4),
      u('rogue', 5, 4), u('mage', 2, 5), u('tinker', 4, 5), u('cleric', 3, 6),
    ],
    b: [
      u('druid', 3, 3), u('shaman', 1, 3), u('demonhunter', 5, 3), u('hexmaster', 2, 2),
      u('warlock', 4, 2), u('necromancer', 3, 2), u('musketeer', 3, 1),
    ],
  }
}

export const presets: Record<string, () => { a: TeamSetup; b: TeamSetup }> = {
  mirror: mirrorTeams,
  wallVsBurst: wallVsBurstTeams,
  dotStack: dotStackTeams,
  batch1: batch1Teams,
  fullCatalog: fullCatalogTeams,
}
